import { Component } from '@angular/core';

@Component({
  selector: 'app-autism',
  templateUrl: './autism.component.html',
  styleUrls: ['./autism.component.scss']
})
export class AutismComponent {

}
